import {
  GET_DIRECTOR_BEGIN,
  GET_DIRECTOR_SUCCESS,
  GET_DIRECTOR_ERROR,
  GET_WHYVISIT_BEGIN,
  GET_WHYVISIT_SUCCESS,
  GET_WHYVISIT_ERROR,
  GET_ABOUTUS_BEGIN,
  GET_ABOUTUS_SUCCESS,
  GET_ABOUTUS_ERROR,
  GET_CONFERENCE_BEGIN,
  GET_CONFERENCE_SUCCESS,
  GET_CONFERENCE_ERROR,
  GET_EXHIBITION_BEGIN,
  GET_EXHIBITION_SUCCESS,
  GET_EXHIBITION_ERROR,
} from "../utils/action";

const About_reducer = (state, action) => {
  switch (action.type) {
    case GET_ABOUTUS_BEGIN:
      return { ...state, aboutus_loading: true };

    case GET_ABOUTUS_SUCCESS:
      return {
        ...state,
        aboutus_loading: false,
        aboutus_data: action.payload,
      };

    case GET_ABOUTUS_ERROR:
      return { ...state, aboutus_loading: false };

    case GET_DIRECTOR_BEGIN:
      return { ...state, director_loading: true };

    case GET_DIRECTOR_SUCCESS:
      return {
        ...state,
        director_loading: false,
        director_data: action.payload,
      };

    case GET_DIRECTOR_ERROR:
      return { ...state, director_loading: false };

    case GET_EXHIBITION_BEGIN:
      return { ...state, exhibition_loading: true };

    case GET_EXHIBITION_SUCCESS:
      return {
        ...state,
        exhibition_loading: false,
        exhibition_data: action.payload,
      };

    case GET_EXHIBITION_ERROR:
      return { ...state, exhibition_loading: false };

    case GET_CONFERENCE_BEGIN:
      return { ...state, conference_loading: true };

    case GET_CONFERENCE_SUCCESS:
      return {
        ...state,
        conference_loading: false,
        conference_data: action.payload,
      };

    case GET_CONFERENCE_ERROR:
      return { ...state, conference_loading: false };

    case GET_WHYVISIT_BEGIN:
      return { ...state, whyvisit_loading: true };

    case GET_WHYVISIT_SUCCESS:
      return {
        ...state,
        whyvisit_loading: false,
        whyvisit_data: action.payload,
      };

    case GET_WHYVISIT_ERROR:
      return { ...state, whyvisit_loading: false };

    default:
      return state;
  }
};

export default About_reducer;
